(() => {
  'use strict';
  if (document.documentElement.dataset.lumirPaymentOptions) return;
  document.documentElement.dataset.lumirPaymentOptions = 'true';
  const money = n => '$' + new Intl.NumberFormat('es-CO', {maximumFractionDigits: 0}).format(n);
  const style = document.createElement('style');
  style.textContent = `
    .rsi-product-item-image{width:88px!important;height:88px!important;min-width:88px!important;flex:0 0 88px!important}
    .rsi-product-item-image img{width:100%!important;height:100%!important;object-fit:contain!important}
    .lumir-payment-options{grid-column:1/-1;padding:18px;border:1px solid #c9a24a;border-radius:12px;background:#fffdf7;color:#0b1a3c;font:14px/1.5 Arial,sans-serif}
    .lumir-payment-options label{display:flex;gap:10px;cursor:pointer}
    .lumir-payment-options input{width:18px;height:18px;accent-color:#0b1a3c}
    .lumir-payment-options small{display:block;color:#536076}
    .lumir-payment-options button{width:100%;padding:14px;margin-top:12px;background:#0b1a3c;color:white;border:0;border-radius:8px;font-weight:600;cursor:pointer}
    .lumir-payment-options[hidden],.lumir-payment-options [hidden]{display:none!important}
    .lumir-payment-options .lumir-quote{display:flex;justify-content:space-between;gap:12px;margin-top:12px;font-weight:bold}
    form.lumir-prepaid-sample .rsi-submit_button,form.lumir-prepaid-sample .rsi-total-summary-wrapper{display:none!important}
  `;
  document.head.append(style);
  function sync(form) {
    const submit = form.querySelector('.rsi-submit_button');
    if (!submit) return;
    let panel = form.querySelector('.lumir-payment-options');
    if (!panel) {
      panel = document.createElement('section');
      panel.className = 'lumir-payment-options';
      panel.setAttribute('aria-label', 'Pago anticipado');
      panel.innerHTML = `<label><input type="checkbox" data-anticipado><span><strong>Paga anticipado y disfruta un descuento especial</strong><small data-saving></small><small>Wompi estará disponible próximamente.</small></span></label><div data-preview hidden><div class="lumir-quote" aria-live="polite"><span>Total anticipado</span><span data-total></span></div><button type="button" data-wompi>Pagar con Wompi</button><p data-notice role="status">Para hacer tu pedido contra entrega, desmarca «Paga anticipado».</p></div>`;
      const wrapper = submit.closest('.rsi-custom-button-wrapper');
      if (!wrapper) return;
      const shipping = form.querySelector('.rsi-shipping-rates-wrapper');
      if (shipping) shipping.after(panel);
      else wrapper.before(panel);
      panel.querySelector('[data-wompi]').addEventListener('click', () => {
        panel.querySelector('[data-notice]').textContent = 'Wompi aún no está conectado. No se ha enviado ningún pedido ni realizado ningún cobro. Desmarca «Paga anticipado» para pedir contra entrega.';
      });
    }
    const items = Array.from(form.querySelectorAll('.rsi-product-item-wrapper'));
    const qty = items.reduce((n, item) => n + Number(item.querySelector('.rsi-quantity-input')?.value || item.querySelector('.rsi-product-item-quantity')?.textContent || 0), 0);
    const subtitle = items[0]?.querySelector('.rsi-product-item-subtitle')?.textContent || '';
    const size = /\b50\s*ML\b/i.test(subtitle) ? 50 : /\b100\s*ML\b/i.test(subtitle) ? 100 : null;
    const eligible = items.length === 1 && qty === 1 && size !== null;
    panel.hidden = !eligible;
    const checkbox = panel.querySelector('[data-anticipado]');
    if (!eligible) checkbox.checked = false;
    const prepaid = eligible && checkbox.checked;
    const extra = form.querySelector('#oneTickUpsell-1793544746300')?.checked ? 5000 : 0;
    const total = money((size === 50 ? 89000 : 109000) + extra);
    const saving = 'Ahorra ' + money(size === 50 ? 10000 : 20000) + ' pagando antes del envío.';
    if (panel.querySelector('[data-total]').textContent !== total) panel.querySelector('[data-total]').textContent = total;
    if (panel.querySelector('[data-saving]').textContent !== saving) panel.querySelector('[data-saving]').textContent = saving;
    panel.querySelector('[data-preview]').hidden = !prepaid;
    form.classList.toggle('lumir-prepaid-sample', prepaid);
  }
  let scheduled = false;
  const refresh = () => {
    scheduled = false;
    const forms = new Set(Array.from(document.querySelectorAll('.rsi-submit_button'), button => button.closest('form')));
    forms.forEach(form => {if (form) sync(form);});
  };
  new MutationObserver(records => {
    if (records.every(record => record.target.closest?.('.lumir-payment-options'))) return;
    if (!scheduled) {scheduled = true; requestAnimationFrame(refresh);}
  }).observe(document.body, {childList:true, subtree:true, characterData:true});
  document.addEventListener('change', refresh);
  document.addEventListener('input', event => {if (event.target.matches('.rsi-quantity-input')) refresh();});
  document.addEventListener('submit', event => {
    if (event.target.matches('form.lumir-prepaid-sample')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  refresh();
})();